// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1Q9OC","inputDescription":"styles_inputDescription__3jKFT"};